<template>
    <div>
        <audit-list />
    </div>
    
</template>
<script>
import AuditList from "../components/AuditList"

export default {
  components: { 
    AuditList
  }
};
</script>

<style>
</style>
  